import QuickLinks from './quick_links';
import QuickLinkAdd from './quick_link_add';
import QuickLinkEdit from './quick_link_edit';

export {
    QuickLinks,
    QuickLinkAdd,
    QuickLinkEdit
};
